var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},_vm._l((_vm.multaskoHomeData.data),function(data,idx){return _c('Banner',{key:idx,attrs:{"data":data,"isCategories":false},on:{"viewnote":_vm.emitOpenNoteViewerHome}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }